import "../Minute/Minute.css";
import { CSSProperties, useContext } from "react";
import { usePreference } from "../../../context/usePreference";
import thousandSeparator from "../../../utils/ThousandSeparator";
import { getDataObjArray } from "../Sidebar/SideBarUtils";
import { getCSSPropertiesHeight, getClassNameByIndice, getStyleByIndice, handleValueDataAudienceIndice } from "./MediaCompUtils";
import i18n from "../../../i18n";
import { UiContext } from "../../../context/UiContext";

export function MediaCompRow({ rowContent, rowID, Indice, dataFormatada }) {
  function getMinuteCellComponent() {
    if(document.querySelector("#divTableMinuteRight .tableRow .cellRows") != null) {
      return document.querySelector("#divTableMinuteRight .tableRow .cellRows");
    }
    else if(document.querySelector("#divTableMinuteRight .tableRowAlert .cellRows") != null) {
      return document.querySelector("#divTableMinuteRight .tableRowAlert .cellRows");
    }
  }
  const row: string[] = [];
  const {
    channelsLength, calculateEmissorasColumnInt
} = useContext(UiContext);
  const cellWidth = calculateEmissorasColumnInt(channelsLength);
  let langData = "";
  let langHora = "";
  langData = dataFormatada.trim().slice(0, 10);
  langHora = dataFormatada.trim().slice(10);

  if ((i18n?.language?.toUpperCase() === "EN-US")) {

    let [day, month, year] = langData.split('-');
    let formattedDate = `${month}-${day}-${year}`;


    dataFormatada = formattedDate + langHora;
  }

  rowContent.map((val, valId) => {
    if (valId > 3) {
      row.push(val);
    }
  });
  const u = usePreference();

  const rowHeight: CSSProperties = getCSSPropertiesHeight(u.userPreference?.TipoBase, Indice);
  let classColor = "tableRow";

  if (rowID % 2 !== 0) {
    classColor += " even";
  }

  if (rowContent[0] === '0' && rowContent[2] === "") {
    classColor = classColor.replace(" even", "");
    classColor += " tableRowAlert2";
  }

  if (Indice > 2) {
    classColor += " dobleIndice";
  }

  function renderRows(indice, rowContent, cellWidth) {
    const renderCell = (val) => {
      if (val === "-|-") {
        const splitVal = val.split("|");
        return (
          <div id="audiencedobleIndiceEmpty">
            {splitVal[0]}
            <br />
            <span className="secondary">{splitVal[1]}</span>
          </div>
        );
      } else if (indice !== 5) {
        return (
          <div>
            {thousandSeparator.formatWithSeparator(val.split("|")[0])}
            <br />
            <span className="secondary">
              {val.split("|")[1] === "-"
                ? val.split("|")[1]
                : handleValueDataAudienceIndice(val.split("|")[1], "%")}
            </span>
          </div>
        );
      } else {
        return (
          <div>
            {handleValueDataAudienceIndice(val.split("|")[0], "%")}
            <br />
            <span className="secondary">
              {val.split("|")[1] === "-"
                ? val.split("|")[1]
                : handleValueDataAudienceIndice(val.split("|")[1], "%")}
            </span>
          </div>
        );
      }
    };
    const renderCellEmpty = (val) => {
      return (
        <td
          className={"tableFirstGridWhite " + getClassNameByIndice(Indice)}
          key={val}
          style={{
            ...getStyleByIndice(Indice),
            width: `${cellWidth}px`,
          }}
        >
          {""}
        </td>
      );
    }
    let dataList = getDataObjArray(row);
    if (rowContent[1] == "" || rowContent[2] == 0) {
      return Array.from({ length: channelsLength }, (_, index) => renderCellEmpty(index));
    }
    switch (indice) {
      case 0:
        return dataList.map((val, rowID) => (
          <td className="cellRows" key={val.ValueId} style={{ minWidth: `${cellWidth}px` }} >
            {thousandSeparator.formatWithSeparator(val.DataValueArray)}
          </td>
        ));
      case 3:
      case 4:
      case 5:
        return dataList.map((val, rowID) => (
          <td className="cellRows" key={val.ValueId} style={{ minWidth: `${cellWidth}px` }}>
            {renderCell(val.DataValueArray)}
          </td>
        ));
      default:
        return dataList.map((val, rowID) => (
          <td className="cellRows" key={val.ValueId} style={{ minWidth: `${cellWidth}px` }}>
            {val.DataValueArray === "-"
              ? val.DataValueArray
              : handleValueDataAudienceIndice(val.DataValueArray, "%")}
          </td>
        ));
    }
  }
  let colSpan = rowContent[1] == "" || rowContent[2] == 0 ? channelsLength + 1 : row.length;
  return (
    <>
      
      <tr className={classColor} style={{ height: '25px' }}>
        <td colSpan={colSpan} style={{ backgroundColor: 'rgba(0,0,0, 0.7)', fontSize: '14px', color: 'white', paddingLeft: '10px', width: '-webkit-fill-available', textAlign: "left" }}>
          {dataFormatada}
        </td>
      </tr>
      <tr className={classColor} style={rowHeight}>
        {renderRows(Indice, rowContent, cellWidth)}
        
      </tr>
    </>
  );
}